import styled from '@emotion/styled';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import { DatePicker } from 'ui/components/features/DatePicker/DatePicker';
import { FormError } from 'ui/components/elements/FormError/FormError';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    overflow-y: auto;
`;

const Desc = styled.p`
    margin-block: 12px 20px;
    padding: 0 4px;
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const RemindMsg = styled.p`
    font-size: var(--font-medium);
    color: #ff4500;
    padding-bottom: 5px;
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    margin: 10px auto 0 auto;
    border: none;
    outline: none;
`;

const ErrorMsgContainer = styled.div`
    margin-right: auto;
`;

interface Props {
    control: any;
    showRemindMessage?: boolean;
    errorMsg?: string;
    meetingDate?: string;
    onClick: () => void;
}

/**
 * 面談日設定モーダル
 */
export const SetMeetingDate: React.FC<Props> = ({
    showRemindMessage = false,
    meetingDate,
    control,
    errorMsg,
    onClick,
}) => {
    return (
        <Wrapper>
            <Descriptions>
                <Desc>{meetingDate ? '面談日を変更しますか？' : '面談日を確定してください。'}</Desc>
                {showRemindMessage && (
                    <RemindMsg>
                        ※マッチングから2週間が経過しています。
                        <br />
                        お相手と相談して面談日を設定してください。
                    </RemindMsg>
                )}
            </Descriptions>
            <Controller
                name="meeting_date"
                defaultValue={meetingDate ? dayjs(meetingDate).format('YYYY/MM/DD HH:mm') : ''}
                control={control}
                render={({ field }) => <DatePicker {...field} format="YYYY/MM/DD HH:mm" />}
            />
            <ErrorMsgContainer>{errorMsg && <FormError message={errorMsg} />}</ErrorMsgContainer>

            <SubmitButton onClick={onClick}>{meetingDate ? '変更する' : '確定する'}</SubmitButton>
        </Wrapper>
    );
};
